<div fxLayout="column">
  @if (img.autoplay==0) {
    <div fxLayout="column">
    <video controls (click)="playVideo()" loop="loop" [style.height]="item.height" [ngStyle.lt-md]="{
      'padding-top': i > 0 ? item.categoryId6 == 1 ? '10px' : 
      i == 0 ? '10px' : '0px' : '0px',
      'height': item.heightMob
  }" [ngClass]="item.customField9==2 ? '' : 'collection-banner '"
        fxLayoutAlign="space-evenly stretch">
       <source [src]="serverPath + img.img | safe: 'resourceUrl'" type="video/mp4">
        Your browser does not support the video tag.
      </video>
    </div>
  }

  @if (img.autoplay==1) {
    <div fxLayout="column">
      <video oncanplay="this.play()" onloadedmetadata="this.muted = true" autoplay loop  playsinline="playsinline"
      [style.height]="item.height" [ngStyle.lt-md]="{
        'padding-top': i > 0 ? item.categoryId6 == 1 ? '10px' : (i == 0 ? '10px' : '0px') : '0px',
        'height': item.heightMob
    }" [ngClass]="item.customField9 == 2 ? '' : 'collection-banner '"
        fxLayoutAlign="space-evenly stretch">
        <source [src]="serverPath + img.img | safe: 'resourceUrl'" type="video/mp4">
      </video>
    </div>
  }

  @if (img.autoplay==2) {
    <div fxLayout="column" style="width: 100%;"  >
      <video 
      oncanplay="this.play()" 
      onloadedmetadata="this.muted = true" 
      autoplay muted loop="loop"
      [ngStyle.lt-md]="{
          'padding-top': i > 0 ? (item.categoryId6 == 1 ? '10px' : (i == 0 ? '10px' : '0px')) : '0px',
          'height': item.heightMob,
          'width': '100%'
      }"
      [ngStyle]="{
        'height': item.height,
       
    }"
      [ngClass]="item.customField9 == 2 ? '' : 'collection-banner'"
      fxLayoutAlign="space-evenly stretch">
      <source [src]="serverPath + img.img | safe: 'resourceUrl'" type="video/mp4">
      Your browser does not support the video tag.
  </video>

    </div>
  }

  <div fxLayout="column">
    @if (img.customField1 !== null) {
      <span>
        @if (img.customField1.length>0) {
          <span fxLayoutAlign="space-evenly center" fxLayoutGap="5px"
            class="padding-10">
            <p [style.font-size]="item.customField18"
              [ngStyle.lt-md]="{ 'font-size': item.customField17 }">{{ img.customField1 }}
            </p>
          </span>
        }
      </span>
    }
  </div>

  <div fxLayout="column">
    @if (img.customField13!== null) {
      <div>
        @if (img.customField13==0) {
          <div class="customer " fxLayoutAlign="start center">
            @if (img.customField12) {
              <button (click)="img.navigation==0?imageNavigation(img.catId):link(img.navigatedUrl)"
                [style.color]="'#ffffff'" [style.border-radius]="img.customField11" class="primary"
                mat-flat-button>
                {{img.customField12}}
              </button>
            }
          </div>
        }
        @if (img.customField13==1) {
          <div class="customer" fxLayoutAlign="center center">
            @if (img.customField12) {
              <button (click)="img.navigation==0?imageNavigation(img.catId):link(img.navigatedUrl)"
                [style.color]="'#ffffff'" [style.border-radius]="img.customField11" class="primary"
                mat-flat-button>
                {{img.customField12}}
              </button>
            }
          </div>
        }
        @if (img.customField13==2) {
          <div class="customer">
            @if (img.customField12) {
              <button fxFlex (click)="img.navigation==0?imageNavigation(img.catId):link(img.navigatedUrl)"
                [style.color]="'#ffffff'" [style.border-radius]="img.customField11" class="primary"
                mat-flat-button>
                {{img.customField12}}
              </button>
            }
          </div>
        }
      </div>
    }
  </div>
</div>
